import React from 'react';
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
// import PostAddIcon from '@material-ui/icons/PostAdd'
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import AddIcon from '@material-ui/icons/Add';
import '../Timeline.css';
var image1 = 'https://images.unsplash.com/photo-1565822737580-090f3d63b27d?ixlib=rb-1.2.1&w=1000&q=80';
var image2 = 'https://images.unsplash.com/photo-1565822737580-090f3d63b27d?ixlib=rb-1.2.1&w=1000&q=80';
var image3 = 'https://images.unsplash.com/photo-1565822737580-090f3d63b27d?ixlib=rb-1.2.1&w=1000&q=80';
var title1 = 'Create an account';
var title2 = 'Give us a little information';
var title3 = 'Shop from Designers around the world';
var message1 = 'Create an account using Google, Facebook, or your Email address';
var message2 = 'Fill out our quick style-me form that gives us an idea of your personal style';
var message3 = 'Browse clothing from all our Designers';
var Buyer = function () {
    return (React.createElement("div", { className: 'timelineMain' },
        React.createElement(VerticalTimeline, null,
            React.createElement(VerticalTimelineElement, { className: 'vertical-timeline-element--work', contentStyle: { background: 'rgb(33, 150, 243)', color: '#fff' }, contentArrowStyle: { borderRight: '7px solid  rgb(33, 150, 243)' }, iconStyle: { background: 'rgb(33, 150, 243)', color: '#fff' }, icon: React.createElement(AccountCircleIcon, null) },
                React.createElement("h3", { style: { color: 'white' }, className: 'vertical-timeline-element-title' }, title1),
                React.createElement("p", null, message1)),
            React.createElement(VerticalTimelineElement, { className: 'vertical-timeline-element--work', contentStyle: { background: '#6f6f6f', color: '#fff' }, contentArrowStyle: { borderRight: '7px solid  #6f6f6f' }, iconStyle: { background: '#6f6f6f', color: '#fff' }, icon: React.createElement(AddIcon, null) },
                React.createElement("h3", { style: { color: 'white' }, className: 'vertical-timeline-element-title' }, title2),
                React.createElement("p", null, message2)),
            React.createElement(VerticalTimelineElement, { className: 'vertical-timeline-element--work', contentStyle: { background: 'rgb(33, 150, 243)', color: '#fff' }, contentArrowStyle: { borderRight: '7px solid  rgb(33, 150, 243)' }, iconStyle: { background: 'rgb(33, 150, 243)', color: '#fff' }, icon: React.createElement(LocalShippingIcon, null) },
                React.createElement("h3", { style: { color: 'white' }, className: 'vertical-timeline-element-title' }, title3),
                React.createElement("p", null, message3)))));
};
export default Buyer;



//////////////////
// WEBPACK FOOTER
// ./src/containers/FrontPg/ImageCarousel/PublicDisplay/Buyer/Buyer.tsx
// module id = 1545
// module chunks = 0 1 2 3